import React, { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function CheckboxesTags(props) {
  const { groups, user_id } = props;

  const [open, setOpen] = React.useState(false);

  const [state, setState] = React.useState({
    user_id: "",
    preconfig: [],
    custom: [],
    hvm: [],
    sharedvm: [],
    cloud: [],
    wise: [],
    manual: [],
    saas: []
  });

  const [cloudlablist, setCloudlablist] = useState([]);
  const [sharedvmlist, setSharedvmlist] = useState([]);
  const [virtuallablist, setVirtuallablist] = useState([]);
  const [costomlablist, setCostomlablist] = useState([]);
  const [wiselablist, setWiselablist] = useState([]);
  const [preconfiguredlablist, setPreconfiguredlablist] = useState([]);
  const [manuallablist, setManuallablist] = useState([]);
  const [saslablist, setSaslablist] = useState([]);

  // Add this state to track if any selection has been made
  const [isAssignEnabled, setIsAssignEnabled] = useState(false);
  // Add this useEffect hook to update the isAssignEnabled state
  useEffect(() => {
    const hasSelections =
      state.preconfig.length > 0 ||
      state.custom.length > 0 ||
      state.hvm.length > 0 ||
      state.sharedvm.length > 0 ||
      state.cloud.length > 0 ||
      state.wise.length > 0 ||
      state.manual.length > 0 ||
      state.saas.length > 0;
    setIsAssignEnabled(hasSelections);
  }, [state]);

  const handleClickOpen = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/cloudasslabs/${user_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => setCloudlablist(data))
      .catch((error) => {
        console.error(error);
      });
    fetch(`${process.env.REACT_APP_API_URL}/api/sharedvmasslabs/${user_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => setSharedvmlist(data))
      .catch((error) => {
        console.error(error);
      });
    fetch(`${process.env.REACT_APP_API_URL}/api/hypervmasslabs/${user_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => setVirtuallablist(data))
      .catch((error) => {
        console.error(error);
      });
    fetch(`${process.env.REACT_APP_API_URL}/api/customaslabs/${user_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => setCostomlablist(data))
      .catch((error) => {
        console.error(error);
      });
    fetch(`${process.env.REACT_APP_API_URL}/api/wiseasslabs/${user_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => setWiselablist(data))
      .catch((error) => {
        console.error(error);
      });
    fetch(`${process.env.REACT_APP_API_URL}/api/preconfasslabs/${user_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => setPreconfiguredlablist(data))
      .catch((error) => {
        console.error(error);
      });
    fetch(`${process.env.REACT_APP_API_URL}/api/manuallablist/${user_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => setManuallablist(data))
      .catch((error) => {
        console.error(error);
      });
    fetch(`${process.env.REACT_APP_API_URL}/api/saslablist/${user_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => setSaslablist(data))
        .catch((error) => {
          console.error(error);
        });
    const id = "user_id";
    setState((prevState) => ({
      ...prevState,
      [id]: user_id,
    }));
    setOpen(true);
  };

  // console.log("manuallablist",manuallablist);

  const handleClose = () => {
    setOpen(false);
  };

  const handlePreconfigOnChange = (event, value) => {
    event.preventDefault();
    const id = "preconfig";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCustomOnChange = (event, value) => {
    event.preventDefault();
    const id = "custom";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleWiseOnChange = (event, value) => {
    event.preventDefault();
    const id = "wise";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleHyperOnChange = (event, value) => {
    event.preventDefault();
    const id = "hvm";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSharedOnChange = (event, value) => {
    event.preventDefault();
    const id = "sharedvm";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleManualOnChange = (event, value) => {
    event.preventDefault();
    const id = "manual";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSasOnChange = (event, value) => {
    event.preventDefault();
    const id = "saas";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCloudOnChange = (event, value) => {
    event.preventDefault();
    const id = "cloud";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    const data = {
      user_id: state.user_id,
      preconfig: state.preconfig,
      custom: state.custom,
      hvm: state.hvm,
      sharedvm: state.sharedvm,
      cloud: state.cloud,
      wise: state.wise,
      manual: state.manual,
      saas: state.saas
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/userassign/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.reload();
      })
      .catch((error) => {
        window.location.reload();
      });
    setOpen(false);
  };
  return (
    <div>
      <Tooltip title="Assign Labs" arrow>
        <span>
          <IconButton
            aria-label="add"
            disabled={groups[0] === 4 ? false : true}
            onClick={handleClickOpen}
            sx={{ borderRadius: '50px' }}
          >
            <LibraryAddIcon color={groups[0] === 4 ? "primary" : ""} />
          </IconButton>
        </span>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Choose the lab from below list"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="p-4">
              <Typography variant="subtitle2" component="subtitle2">
                Preconfigured
              </Typography>
              <Autocomplete
                multiple
                id="preconfig"
                name="preconfig"
                options={preconfiguredlablist}
                disableCloseOnSelect
                onChange={(event, value) => {
                  handlePreconfigOnChange(event, value);
                }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      id="preconfig"
                    />
                    {option.name}
                  </li>
                )}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField
                    id="preconfig"
                    {...params}
                    label="Preconfigured"
                  />
                )}
              />
            </div>
          </DialogContentText>
          <DialogContentText>
            <div className="p-4">
              <Typography variant="subtitle2" component="subtitle2">
                Custom
              </Typography>
              <Autocomplete
                multiple
                id="custom"
                name="custom"
                options={costomlablist}
                disableCloseOnSelect
                onChange={(event, value) => {
                  handleCustomOnChange(event, value);
                }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      id="custom"
                    />
                    {option.name}
                  </li>
                )}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField id="custom" {...params} label="Custom" />
                )}
              />
            </div>
          </DialogContentText>
          <DialogContentText>
            <div className="p-4">
              <Typography variant="subtitle2" component="subtitle2">
                Wise
              </Typography>
              <Autocomplete
                multiple
                id="wise"
                name="wise"
                options={wiselablist}
                disableCloseOnSelect
                onChange={(event, value) => {
                  handleWiseOnChange(event, value);
                }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      id="wise"
                    />
                    {option.name}
                  </li>
                )}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField id="wise" {...params} label="Wise" />
                )}
              />
            </div>
          </DialogContentText>
          <DialogContentText>
            <div className="p-4">
              <Typography variant="subtitle2" component="subtitle2">
                Hypervised
              </Typography>
              <Autocomplete
                multiple
                id="hvm"
                name="hvm"
                options={virtuallablist}
                disableCloseOnSelect
                onChange={(event, value) => {
                  handleHyperOnChange(event, value);
                }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      id="hvm"
                    />
                    {option.name}
                  </li>
                )}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField
                    id="hvm"
                    {...params}
                    label="Hypervised"
                  />
                )}
              />
            </div>
          </DialogContentText>
          <DialogContentText>
            <div className="p-4">
              <Typography variant="subtitle2" component="subtitle2">
                Shared
              </Typography>
              <Autocomplete
                multiple
                id="sharedvm"
                name="sharedvm"
                options={sharedvmlist}
                disableCloseOnSelect
                onChange={(event, value) => {
                  handleSharedOnChange(event, value);
                }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      id="sharedvm"
                    />
                    {option.name}
                  </li>
                )}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField id="sharedvm" {...params} label="Shared" />
                )}
              />
            </div>
          </DialogContentText>
          <DialogContentText>
            <div className="p-4">
              <Typography variant="subtitle2" component="subtitle2">
                Cloud
              </Typography>
              <Autocomplete
                multiple
                id="cloud"
                name="cloud"
                options={cloudlablist}
                disableCloseOnSelect
                onChange={(event, value) => {
                  handleCloudOnChange(event, value);
                }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      id="cloud"
                    />
                    {option.name}
                  </li>
                )}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField id="cloud" {...params} label="Cloud" />
                )}
              />
            </div>
          </DialogContentText>
          <DialogContentText>
            <div className="p-4">
              <Typography variant="subtitle2" component="subtitle2">
                Manual
              </Typography>
              <Autocomplete
                multiple
                id="manual"
                name="manual"
                options={manuallablist}
                disableCloseOnSelect
                onChange={(event, value) => {
                  handleManualOnChange(event, value);
                }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      id="manual"
                    />
                    {option.name}
                  </li>
                )}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField id="manual" {...params} label="Manual" />
                )}
              />
            </div>
          </DialogContentText>
          <DialogContentText>
            <div className="p-4">
              <Typography variant="subtitle2" component="subtitle2">
                SaaS
              </Typography>
              <Autocomplete
                multiple
                id="saas"
                name="saas"
                options={saslablist}
                disableCloseOnSelect
                onChange={(event, value) => {
                  handleSasOnChange(event, value);
                }}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      id="saas"
                    />
                    {option.name}
                  </li>
                )}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField id="saas" {...params} label="SaaS" />
                )}
              />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cancel" arrow>
            <Button autoFocus onClick={handleClose} color="primary" sx={{ borderRadius: '50px', px: 3, py: 1 }}>
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Assign" arrow>
            <span>
              <Button onClick={handleSubmitClick} color="primary" autoFocus disabled={!isAssignEnabled} sx={{ borderRadius: '50px', px: 3, py: 1 }}>
                Assign
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </div>
  );
}
